export default __webpack_public_path__ + "static/media/buyOneGetOneDifferentProduct.645c7533.webp";